import { Skeleton as UiSkeleton, styled, Typography, Palette } from "@mui/material"

const BORDER_RADIUS = 8
const HEIGHT = 8

export const Mask = styled("div")(({ theme }) => ({
    borderRadius: BORDER_RADIUS,
    height: "fit-content",
    overflow: "hidden",
    width: "100%",
    marginBottom: theme.spacing(3),
}))

interface CatalogItemsGradingBarWrapperProps {
    itemsCount: number
}

export const CatalogItemsGradingBarWrapper = styled("div", {
    shouldForwardProp: (prop) => prop !== "itemsCount",
})<CatalogItemsGradingBarWrapperProps>(({ itemsCount }) => {
    const padding = itemsCount <= 1 ? 0 : (itemsCount - 1) * BORDER_RADIUS;

    return {
        display: "flex",
        height: HEIGHT,
        position: "relative",
        width: `calc(100% + ${padding}px)`,
    };
});

export const EmptyBarItem = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["action/disabled"].main,
    borderRadius: BORDER_RADIUS,
    display: "flex",
    height: HEIGHT,
    marginBottom: theme.spacing(3),
    position: "absolute",
    width: "100%",
}))

interface SignsGradingBarItemProps {
    color: keyof Palette
    index: number
    width: number
}

export const SignsGradingBarItem = styled("div", {
    shouldForwardProp: (prop) => !["color", "index", "width"].includes(prop as string),
})<SignsGradingBarItemProps>(({ color, index, width }) => ({
    backgroundColor: color,
    borderRadius: BORDER_RADIUS,
    height: HEIGHT,
    transform: `translateX(${index * -BORDER_RADIUS}px)`,
    width: `${width}%`,
    zIndex: 3 - index,
}))

export const CatalogItemsCountsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(3),
    justifyContent: "space-between",
}))

export const Skeleton = styled(UiSkeleton)({
    height: 91,
    transform: "scale(1)",
    width: "100%",
})

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
    textAlign: "center",
}))